import { createUseStyles } from 'react-jss';

import { theme } from '@align-cpf/uikit-styles';
const iconsGap = theme.spacing.sp02;
const iconWidth = 20;

const { spacing, colors } = theme;

export default createUseStyles(
  {
    root: {
      position: 'relative',
      display: 'block',
      flexBasis: '100%',
    },

    trigger: {
      '&:hover $chevron': {
        color: colors.iconPrimary,
      },

      '&:hover $iconDisabled, &:hover $iconDisabled $chevron': {
        color: colors.iconDisabled,
      },
    },

    iconContainer: {
      position: 'absolute',
      top: 0,
      bottom: 0,
      right: spacing.sp04,
      display: 'flex',
      flexWrap: 'nowrap',
      gap: iconsGap,
      alignItems: 'center',
      color: colors.iconTertiary,
      cursor: 'pointer',
    },

    chevron: {},

    clear: {
      '&:hover': {
        color: colors.iconPrimary,
      },
    },

    iconDisabled: {
      pointerEvents: 'none',
      color: colors.iconDisabled,
    },

    input: {
      cursor: 'pointer',
      '&::placeholder': {
        color: colors.textPrimary,
      },

      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      paddingRight: `calc(${iconWidth}px + ${iconsGap} * 4)`,
    },

    clearable: {
      paddingRight: `calc(${iconWidth}px * 2 + ${iconsGap} * 4)`,
    },

    inputActive: {
      borderColor: colors.borderFocus,
    },

    invert: {
      transform: 'rotate(180deg)',
    },
  },
  {
    name: 'Dropdown',
  },
);
